import Vue from 'vue'
import App from './App.vue'
import router from './router'
import global from "./assets/js/global"
import commonFun from "./assets/js/commonFun"
import { Switch,Swipe, SwipeItem} from 'vant';
import { Toast} from 'vant';
Vue.use(Toast);
Vue.config.productionTip = false
Vue.prototype.$global= global;
Vue.prototype.commonFun = commonFun;
Vue.use(Switch);
Vue.use(Swipe);
Vue.use(SwipeItem);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
